// const baseURL = 'http://localhost/public/'; //para backend en xamp
// const baseURL = 'http://www.productos-catamarca.infinityfreeapp.com'; //para Backend en infitiry Free
// const baseURL = 'http://www.back-catamarca-venta.fwh.is'; //para Backend en infitiry Free nueva prueba
const baseURL = '' //funciona sin https 
export default baseURL;